const controlSelector = 'input:not([type="hidden"], [type="checkbox"], [type="radio"]), textarea, select';

const update = (control) => {
	const field = control.closest('.gfield');
	if (!field) return;

	if (control.type === 'file') {
		const text = field.querySelector('.gform-field-label__text');
		if (!text) return;
		text.dataset.label ??= text.textContent;
		text.textContent = control.files?.[0]?.name || text.dataset.label;
	}

	field.classList.toggle('is-filled', control.value.trim() !== '');
};

const scan = (root = document) => root.querySelectorAll(`.gform_wrapper ${controlSelector}`).forEach(update);

document.addEventListener('input', (event) => event.target.matches?.(controlSelector) && update(event.target));
document.addEventListener('change', (event) => event.target.matches?.(controlSelector) && update(event.target));
document.addEventListener('gform/post_render', () => scan());
window.jQuery?.(document).on('gform_post_render', () => scan());

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => scan());
} else {
	scan();
}
